import {
  arSA,
  bg,
  ca,
  cs,
  da,
  de,
  el,
  enUS,
  es,
  fi,
  fr,
  hr,
  hu,
  is,
  it,
  lt,
  lv,
  nb,
  nl,
  pl,
  pt,
  ro,
  ru,
  sk,
  sl,
  sq,
  sr,
  sv,
  tr,
  uk,
  vi,
} from 'date-fns/locale';
import { setDateFnsLocale } from 'shared/helpers/timeHelper';

const localeMap = {
  ar: arSA,
  bg,
  ca,
  cs,
  da,
  de,
  el,
  en: enUS,
  es,
  fi,
  fr,
  hr,
  hu,
  is,
  it,
  lt,
  lv,
  nl,
  no: nb,
  pl,
  pt,
  ro,
  ru,
  sk,
  sl,
  sq,
  sr,
  sv,
  tr,
  uk,
  vi,
};

export const syncDateFnsLocale = localeCode => {
  // eslint-disable-next-line security/detect-object-injection
  setDateFnsLocale(localeMap[localeCode] || enUS);
};
